

export function validationForm() {


    const ValidationForm = (fields = [''], indicators = ['']) => {
        for (const fieldsName of indicators) {
            if (!fields[fieldsName] || fields[fieldsName].toString().trim() === "") {
                console.log(fields[fieldsName])
                const messageValidation = {
                    type: 'negative',
                    message: `Campo ${fieldsName} está vazio`,
                    isErro: true
                }
                return messageValidation
            }
        }
        return {
            type: '',
            message: ``,
            isErro: false
        }
    }

    return {
        ValidationForm
    }
}